module.exports = __webpack_public_path__ + "img/desc_illust.bff956fd.png";